import React, { useEffect, useState } from "react";
import { Link,useParams,useNavigate } from "react-router-dom";
import { StateUseContext } from "../context/UserDetailContext";
import UserDetail from "../components/StudentBankDetail/UserDetail";
import BankDetailForm from "../components/StudentBankDetail/BankDetailForm";
import { getCashWinnerBankDetailStatus } from "../actions/StudentAction";


const StudentBankDetail = () => {
    const { userDetail } = StateUseContext();
    const [showForm,setShowForm] = useState(false);
    const [loading,setLoading] = useState();
    const params = useParams();
    const navigate = useNavigate();

    const { name, form_num, father_name,id } = userDetail || {};
  
  useEffect(()=> {
    if(+params?.id !== id){
      navigate('/student/dashboard')
    }
  },[params,id])
  

  useEffect(() => {

    const checkCashWinnerEligibleStatus = async () => {
      try {
        setLoading(true)
        await getCashWinnerBankDetailStatus(form_num).then((res) => {
            if(res.status){
              if(res.student_id ===id){
                setLoading(false)
                setShowForm(true)
              }
            }
            else if(res.status === false && res.prize_distribution ===1){
                setLoading(false)
                setShowForm(false)
            }
            else{
              navigate('/student/dashboard')
            }
        });
      } catch (error) {
        console.log(error);
      }
    };

    checkCashWinnerEligibleStatus()
  }, [form_num]);

  return (
    <div className="container mt-5 referral">
      <div className="row align-items-center">
        <div className="col-6">
          <h2 className="fs-6 fs-lg-4 fs-md-5 fw-bold my-0">
            Student bank detail
          </h2>
        </div>
        <div className="col-6 text-end">
          <Link
            to={"/student/dashboard"}
            className="go-to-dashLink text-secondary px-3 border-light border fw-medium py-2 bg-white shadow-sm rounded d-inline-block text-decoration-none"
          >
            Go To Dashboard
          </Link>
        </div>
      </div>

      <div className="alert alert-warning mt-4 fw-bold" role="alert">
        <b>NOTE</b> : Please fill the details to receive your cash reward. In
        case of any queries, write to us at{" "}
        <b className="text-lowercase">overseascontact@tallentex.com</b> or
        contact your respective country representative.
      </div>

      <div className="card bg-secondary-light cash_winnerDetail p-4">
        <UserDetail name={name} form_num={form_num} father_name={father_name} />
      </div>
        {loading ? (
            <div className="text-center py-5">
                <div className="spinner-grow spinner-grow-sm mt-2" role="status">
                        <span  className='visually-hidden'>Loading...</span> 
                </div> <span className='d-block fw-bold fs-6 mt-1 ms-2'>Verifying eligibility status...</span>
            </div>
        ):(
            <>
             {showForm ? (
                    <div className="card p-4 mt-4 mb-5">
                        <BankDetailForm userDetail={userDetail !== undefined && userDetail} />
                    </div>
                ) : (
                    <div className='bank-detail-submitted mt-5'>
                        <h3 className='text-success text-center fw-bold'>You have successfully submitted bank details form.</h3>
                    </div>
                )
             }
            </>
        )}
       
      

    </div>
  );
};

export default StudentBankDetail;
